import { useMutation } from "react-query";
import getCampaign from "../services/getCampaign";
function useGetCampaignMutation() {
  return useMutation(["get-campaign"], getCampaign);
}

export default useGetCampaignMutation;
